import {
  Destinatario,
  EnumDestinatarioCodiceModalitaTrasmissione,
} from '@framework/api-client';
import { ComunicazioneDTO } from '@framework/api-client/src/api/backoffice/schemas';
import { useTranslation } from '@framework/i18n';
import { ISODate } from '@framework/ui';
import * as React from 'react';
import { useTheme } from 'styled-components';
import { CommunicationUserTypeTag } from '../CommunicationUserTypeTag';
import { CommunicationRecipientStatusIcon } from './CommunicationRecipientStatusIcon';
import { UserName } from './UserName';

interface CommunicationRecipientProps {
  recipient: Destinatario | undefined;
  communication: ComunicazioneDTO | undefined;
}

function getNotSendTooltip(recipient: Destinatario) {
  switch (recipient.codiceModalitaTrasmissione) {
    case EnumDestinatarioCodiceModalitaTrasmissione.MAIL:
      return 'Mail non inviata';
    case EnumDestinatarioCodiceModalitaTrasmissione.PEC:
      return 'PEC non inviata';
    case EnumDestinatarioCodiceModalitaTrasmissione.SERVIZIO:
      return 'In attesa del servizio';
    default:
      return 'Non inviata';
  }
}

/**
 * Singolo destinatario comunicazione
 */
export function CommunicationRecipient(props: CommunicationRecipientProps) {
  const { recipient, communication } = props;
  const theme = useTheme();
  const { t } = useTranslation();

  if (!recipient) return null;

  return (
    <div key={recipient.id}>
      <UserName
        key={recipient.id}
        name={recipient.denominazione ?? 'N/A'}
        icon={<CommunicationRecipientStatusIcon recipient={recipient} />}
        tag={
          <CommunicationUserTypeTag
            mini
            type={recipient.tipoDestinatarioEnum}
          />
        }
        hasProtocol={
          communication?.tipoComunicazione?.flProtocollazione ?? false
        }
        sendDate={
          recipient.dataInvio && (
            <div>
              {t('communication-recipient.send-date', 'Data invio')}:{' '}
              <b>
                <ISODate date={recipient.dataInvio} format="DD/MM/YYYY" />
              </b>
            </div>
          )
        }
        registrationDate={
          recipient.dataRegistrazione && (
            <div>
              {t(
                'communication-recipient.registration-date',
                'Data protocollo',
              )}
              :{' '}
              <b>
                <ISODate
                  date={recipient.dataRegistrazione}
                  format="DD/MM/YYYY"
                />
              </b>
            </div>
          )
        }
        protocolNumber={
          recipient.numeroProtocollo && (
            <div>
              {t('communication-recipient.protocol-number', 'Protocollo')}:{' '}
              <b>{recipient.numeroProtocollo}</b>
            </div>
          )
        }
      />
    </div>
  );
}
